import { render, staticRenderFns } from "./Seo.vue?vue&type=template&id=16abf3f8&scoped=true"
import script from "./Seo.vue?vue&type=script&lang=js"
export * from "./Seo.vue?vue&type=script&lang=js"
import style0 from "./Seo.vue?vue&type=style&index=0&id=16abf3f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16abf3f8",
  null
  
)

export default component.exports